import { useRef } from "react";
import { toInputFieldDateString } from "../../utilities/dateUtilities";
import { DateMegaControl } from "./dateMegaControl"
export const DateRangePicker = ({fromDate, toDate, setDateRange, dropdownPositionRight, showClearOption, hideLabel=false, fullWidth=false}) => {
    const fromDateInputRef = useRef()
    // If the datepicker is positioned to the right of the screen,
    // pass in dropdownPositionRight from the parent as true to ensure dropdown displays in full

    return (
        <div className={`d-flex align-items-center${fullWidth ? ' w-100' : ''}`}>
            {!hideLabel && <label className="m-0 mr-2 nowrap">Date Range</label>}
            <div className={`form-group mb-0 d-flex date-range-picker${fullWidth ? ' flex-grow-1 date-range-picker--full-width' : ''}`}>
                <input
                    className="form-control form-control-sm text-center"
                    id="from-date-picker"
                    ref={fromDateInputRef}
                    type="date"
                    value={toInputFieldDateString(fromDate)}
                    onClick={e => e.target.showPicker()}
                    onChange={e => setDateRange(e.target.value, toDate, null)}
                />
                <input
                    className="form-control form-control-sm text-center"
                    id="to-date-picker"
                    type="date"
                    value={toInputFieldDateString(toDate)}
                    onClick={e => e.target.showPicker()}
                    onChange={e => setDateRange(fromDate, e.target.value, null)}
                />
                <DateMegaControl 
                    setDateRange={(firstDate, lastDate, presetLabel) => setDateRange(firstDate, lastDate, presetLabel)}
                    fromDate={fromDate} 
                    toDate={toDate}
                    onCustomRangeSelect={() => fromDateInputRef.current.showPicker()}
                    isPlacedRight={dropdownPositionRight}
                    showClearOption={showClearOption}
                    onClear={() => setDateRange(null, null)}
                />
            </div>
        </div>
    )
}